module.exports = __webpack_public_path__ + "static/media/location-pin.7e57a46d.svg";